import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import CommonCJAMiddleware from 'yoda-site-components/lib/middlewares/CommonCJAMiddleware';
import CouponMiddleware from 'yoda-site-components/lib/middlewares/CouponMiddleware';
import StyliticsMiddleware from 'yoda-site-components/lib/middlewares/StyliticsMiddleware';
import MiniPDPAnalyticsMiddleware from 'yoda-mini-pdp/lib/middlewares/MiniPDPAnalyticsMiddleware';
import MiniPDPCJAMiddleware from 'yoda-mini-pdp/lib/middlewares/CJAMiddleware';
import AnalyticsMiddleware from './AnalyticsMiddleware';
import CJAMiddleware from './CJAMiddleware';

const rootMiddleware = [
    CommonMiddleware,
    CommonCJAMiddleware,
    AnalyticsMiddleware,
    CJAMiddleware,
    MiniPDPCJAMiddleware,
    MiniPDPAnalyticsMiddleware,
    CouponMiddleware,
    StyliticsMiddleware,
];

export default rootMiddleware;
